module.exports = __webpack_public_path__ + "img/kakao-yellow.e40c9641.png";